import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { safeLocalStorage } from '~/store/safeLocalStorage'

import type { GasAlertKind } from '~/hooks/org/useOrgGas'

const DISMISS_DURATION_MS = 86_400_000 // 24 hours

interface GasAlertDismissState {
  // The band each workspace dismissed and when that dismissal lapses; a
  // different band shows regardless.
  dismissed: Record<string, { kind: GasAlertKind; until: number }>
  dismiss: (orgId: string, kind: GasAlertKind) => void
}

export const useGasAlertDismissStore = create<GasAlertDismissState>()(
  persist(
    (set, get) => ({
      dismissed: {},
      dismiss: (orgId, kind) =>
        set({
          dismissed: {
            ...get().dismissed,
            [orgId]: { kind, until: Date.now() + DISMISS_DURATION_MS },
          },
        }),
    }),
    { name: 'gas-alert-dismissed', storage: safeLocalStorage, version: 1 },
  ),
)
